<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <!-- Page Header -->
    <div class="page-title-wrapper">
        <div class="d-flex justify-content-between flex-row flex-wrap gap-3 align-items-start">
            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Organizations" aria-label="Search Organizations"
                        [ngModel]="userSessionService.organizationsFilter.searchTerm"
                        (ngModelChange)="userSessionService.organizationsFilter.searchTerm = $event"
                        (keyup.enter)="loadOrganizations(false)" aria-describedby="search-description">

                    @if (userSessionService.organizationsFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button"
                            (click)="loadOrganizations(false)" id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by name
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-organization-search-filter (filterApplied)="filterApplied()"></ms-organization-search-filter>

                <ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
                    (selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

                <button type="button" class="btn btn-primary"
                    *ifHasPermission="{
                        requiredPermissions: [OrganizationPermission.Create],
                        userPermissionOnly: true
                    }"
                    (click)="onAddOrganizationClicked()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="d-none d-sm-inline" />
                    Add Organization
                </button>
            </div>
        </div>
    </div>

    <div>
        <div class="d-flex flex-wrap">
            <div class="mb-0 text-start flex-grow-0 w-50" #jumpToElementMobile>
                Showing: {{organizationList().length}} of {{totalCount | number}}
                <div class="badge bg-primary ms-0 ms-sm-2"> Selected: {{selectedCount() | number}} </div>
            </div>
            <div class="flex-grow-1 text-end d-block d-sm-none">
                <button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start"
                    (click)="toggleSelectAll()">
                    <fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
                    <fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
                    {{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
                </button>
            </div>
        </div>

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table class="table table-hover fixed-header placeholder-glow" msResponsiveTable>
                <thead #jumpToElement>
                    <tr>
                        <th scope="col" msResponsiveTableColumn="checkbox" [priority]="1"><input id="toggleAllSelection" name="toggleAllSelection" type="checkbox"
                                class="form-check-input fs-6" [checked]="isSelectAll" (change)="toggleSelectAll()" />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="name" [priority]="1" (click)="toggleSortDirection('Name')">
                            Name
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="(orderBy == organizationListSortOptions.OrganizationNameASC) ? '0.9' : '0.3' "
                                [secondaryOpacity]="(orderBy == organizationListSortOptions.OrganizationNameDESC) ? '0.9' : '0.3' " />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="billingStatus" [priority]="3"
                            (click)="toggleSortDirection('Billing Status')">
                            Billing Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == organizationListSortOptions.BillingStatusASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == organizationListSortOptions.BillingStatusDESC ? '0.9' : '0.3' " />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="orgStatus" [priority]="2"
                            (click)="toggleSortDirection('Organization Status')">
                            Org Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == organizationListSortOptions.OrganizationStatusASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == organizationListSortOptions.OrganizationStatusDESC ? '0.9' : '0.3' " />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="pricingTier" [priority]="6"
                            (click)="toggleSortDirection('Pricing Tier')">
                            Pricing Tier
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == organizationListSortOptions.PricingTierASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == organizationListSortOptions.PricingTierDESC ? '0.9' : '0.3' " />
                        </th>
                        <th scope="col" class="sortable numeric-column" msResponsiveTableColumn="members" [priority]="5"
                            (click)="toggleSortDirection('Members')">
                            Members
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == organizationListSortOptions.MemberCountASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == organizationListSortOptions.MemberCountDESC ? '0.9' : '0.3' " />
                        </th>
                        <th class="fixed-header" scope="col" msResponsiveTableColumn="actions" [priority]="1">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Table Row Start -->
                    @for (organization of displayOrganizations; let i= $index; track organization.organizationId) {
                    <tr class="align-middle" [className]="(i % 2 === 0)? 'even' : 'odd'">

                        <td msResponsiveTableColumn="checkbox" [priority]="1"><input id="toggleAllSelection" type="checkbox" #toggleAllSelection class="form-check-input"
                                [value]="organization.organizationId"
                                [checked]="selectionItems() | itemSelection: organization.organizationId: isSelectAll"
                                (click)="selectionClicked({id: organization.organizationId, checked: toggleAllSelection.checked})" />
                        </td>
                        <td msResponsiveTableColumn="name" [priority]="1">
                            <div class="d-flex align-items-center">
                                <div class="min-w-0">
                                    <div class="fw-bold text-truncate" [class.placeholder]="isLoading"
                                        [msTooltip]="organization.name" msTooltipOnlyIfTruncated>
                                        {{organization.name}}</div>
                                </div>
                            </div>
                        </td>
                        <td msResponsiveTableColumn="billingStatus" [priority]="3">
                            <ms-status-badge [status]="organization.billingStatus" [(isLoading)]="isLoading"></ms-status-badge>
                        </td>
                        <td msResponsiveTableColumn="orgStatus" [priority]="2">
                            <ms-status-badge [status]="organization.status" [(isLoading)]="isLoading"></ms-status-badge>
                        </td>
                        <td msResponsiveTableColumn="pricingTier" [priority]="6">
                            <span [class.placeholder]="isLoading">{{organization?.pricingTier | formatLabel}}</span>
                        </td>
                        <td msResponsiveTableColumn="members" [priority]="5" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{organization?.memberCount | number}}</span>
                        </td>
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
                                    [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li>
                                        <a class="dropdown-item"
                                            [routerLink]="['/organizations/profile/', organization.organizationId]">
                                            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View</a>
                                    </li>

                                    <li>
                                        <a class="dropdown-item" (click)="setActiveOrganization(organization)">
                                            <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9"
                                                class="me-2" />Select</a>
                                    </li>

                                    @if (organization?.status === 'Inactive') {
                                    <li>
                                        <a class="dropdown-item"
                                            (click)="openActivationConfirmationModal(organization)"
                                            [disableWithoutPermission]="{
                                            requiredPermissions: [OrganizationPermission.Status],
                                            userPermissionOnly: true
                                        }">
                                            <fa-duotone-icon icon="power-off" secondaryOpacity="0.9"
                                                class="me-2" />{{ OrganizationsMessagingConstants.ORGANIZATIONS_REACTIVATE_ACTION_LABEL() }}
                                        </a>
                                    </li>
                                    }
                                    @else if (organization?.status === 'Active') {
                                    <li>
                                        <a class="dropdown-item"
                                            (click)="openActivationConfirmationModal(organization)"
                                            [disableWithoutPermission]="{
                                            requiredPermissions: [OrganizationPermission.Status],
                                            userPermissionOnly: true
                                        }">
                                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />{{ OrganizationsMessagingConstants.ORGANIZATIONS_DEACTIVATE_ACTION_LABEL() }}
                                        </a>
                                    </li>
                                    }

                                    <li><a class="dropdown-item" (click)="openAddMemberModal(organization)"
                                        [disableWithoutPermission]="{
                                            requiredPermissions: [MemberPermission.Create],
                                            userPermissionOnly: true
                                        }"
                                        [forceDisabled]="organization?.status === OrganizationStatuses.Deleted">
                                            <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add
                                            Member</a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    }
                    <!-- Table Row End -->
                </tbody>
                <tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
                    [hasNext]="hasNext" [itemCount]="displayOrganizations.length" (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (organization of displayOrganizations; let i= $index; track organization.organizationId) {
            <div class="card d-flex pt-1 d-inline d-sm-none my-3">

                <div class="d-flex flex-column card-body">

                    <div class="d-flex flex-row">
                        <div class="card-left-column d-block-flex text-center">
                            <ms-mobile-card-checkbox [item]="organization" [selectionPrimaryKey]="SelectionPrimaryKeys.OrganizationId"
                                [isSelected]="selectionItems() | itemSelection: organization.organizationId: isSelectAll"
                                (clicked)="selectionClicked($event)" [checkboxSize]="'md'" [checkboxShape]="'circle'" />
                            <div class="mt-3">
                                <ms-status-badge [status]="organization.status" [(isLoading)]="isLoading"></ms-status-badge>
                            </div>
                        </div>

                        <div class="right-card-column w-100">
                            <h5 class="card-title mb-0" [class.placeholder]="isLoading">{{organization.name}}</h5>
                            <div class="fw-semibold" [class.placeholder]="isLoading">{{organization.billingStatus}}
                            </div>
                            <div class="card-text" [class.placeholder]="isLoading">
                                {{organization.pricingTier | formatLabel}}</div>
                        </div>
                    </div>
                </div>

                <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                    [class.placeholder]="isLoading">
                    Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end w-75">
                    <li>
                        <a class="dropdown-item"
                            [routerLink]="['/organizations/profile/', organization.organizationId]">
                            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View
                        </a>
                    </li>

                    <li><a class="dropdown-item" (click)="setActiveOrganization(organization)">
                            <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Select</a>
                    </li>

                    @if (organization?.status === 'Inactive') {
                    <li>
                        <a class="dropdown-item" (click)="openActivationConfirmationModal(organization)"
                            [disableWithoutPermission]="{
                            requiredPermissions: [OrganizationPermission.Status],
                            userPermissionOnly: true
                        }">
                            <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />{{ OrganizationsMessagingConstants.ORGANIZATIONS_REACTIVATE_ACTION_LABEL() }}
                        </a>
                    </li>
                    }
                    @else if (organization?.status === 'Active') {
                    <li>
                        <a class="dropdown-item" (click)="openActivationConfirmationModal(organization)"
                            [disableWithoutPermission]="{
                            requiredPermissions: [OrganizationPermission.Status],
                            userPermissionOnly: true
                        }">
                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />{{ OrganizationsMessagingConstants.ORGANIZATIONS_DEACTIVATE_ACTION_LABEL() }}
                        </a>
                    </li>
                    }

                    <li>
                        <a class="dropdown-item" (click)="openAddMemberModal(organization)"
                            [disableWithoutPermission]="{
                            requiredPermissions: [MemberPermission.Create],
                            userPermissionOnly: true
                        }"
                            [forceDisabled]="organization?.status === OrganizationStatuses.Deleted">
                            <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add Member</a>
                    </li>
                </ul>

            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayOrganizations.length" (jumpToClicked)="jumpToTop($event)">
            </div>

        </div>

        <ms-confirmation-modal #organizationListConfirmationModalRef modalId="organizationListConfirmationModal"
            [(isSubmitting)]="isSubmitting"
            (confirmed)="confirmationConfirmFunction()" (cancelled)="confirmationCancelFunction()" />

        <ms-info-modal #organizationListInfoModalRef modalId="organizationListInfoModal" />

        <ms-member-form-modal [organization]="targetedOrganization"></ms-member-form-modal>

        <ms-add-organization></ms-add-organization>

    </div>
</div>
